import { Text } from '@elkaso-app/web-design';

export interface IAmountCell {
  amount: number | null;
  currency: string | null;
}

export const AmountCell = ({ amount, currency }: IAmountCell) => {
  if (amount === null || amount === undefined) return <Text>---</Text>;

  const formatted = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return <Text>{currency ? `${currency} ${formatted}` : formatted}</Text>;
};
